/**
 * Decides whether the browser PDF→image→VL-OCR fallback should run.
 *
 * The server pipeline already has its own fallbacks (pdf.js text layer →
 * Cloudflare toMarkdown → GLM). `qwen_ocr_unavailable` is set whenever the
 * Qwen PDF path fails, even if the pipeline later succeeded. So the VL
 * fallback must only run when the primary result is genuinely unusable.
 */
export function shouldRunVlFallback(result: any): boolean {
  if (!result) return false;
  const rows = Number(result.transactions_count ?? result.items_count ?? 0);
  const primaryUsable = rows > 0 && result.parse_failed !== true;
  return (
    result.ocr_failed === true ||
    result.parse_failed === true ||
    (result.qwen_ocr_unavailable === true && !primaryUsable)
  );
}
